module.exports = __webpack_public_path__ + "static/media/ic_lock_second.d1d51ae3.svg";